module.exports = __webpack_public_path__ + "img/bootcamp-fee.2ff0ca77.png";